import Vue from 'vue';
import Vuex from 'vuex';

import Neue from './modules/Neue';
import MeineTrends from './modules/Meine_trends'
import AlleRelease from './modules/Alle_release'



Vue.use(Vuex);

export default new Vuex.Store({

    modules: {
        Neue,
        MeineTrends,
        AlleRelease
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js